import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';

import { useRecordContext } from 'react-admin';

const PreformattedTextField = (props) => {
    const {
        source,
    } = props;

    const record = useRecordContext();
    const value = record[source];

    return (
        <Typography component="pre">
            <div dangerouslySetInnerHTML={{ __html: value }} />
        </Typography>
    );
};

PreformattedTextField.propTypes = {
    source: PropTypes.string.isRequired,
};

export default PreformattedTextField;
